define('models/action_history',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        defaults: function () {
            return {
                subject: null,
                action_type: 0,
                created: '',
                subject_details: {},
                action_details: {}
            };
        }
    });
});
